import React from "react";
import { Form } from "@redriver/cinnamon";

const CustomerSignatoryForm = (props) => {
  return (
    <Form {...props}>
      <Form.Input
        field="name"
        label="Name"
        fluid
        required
        placeholder="Name…"
      />
      <Form.Email
        field="email"
        label="Email"
        fluid
        required
        placeholder="Email…"
      />
      <Form.Input
        field="position"
        label="Position"
        fluid
        required
        placeholder="Position…"
      />
      <Form.Input
        field="phoneNumber"
        label="Phone Number"
        fluid
        required
        placeholder="Phone Number…"
      />
      <Form.Input
        field="phoneCountryCode"
        label="Phone Country Code"
        fluid
        required
        placeholder="Phone Country Code…"
      />
    </Form>
  );
};
export default CustomerSignatoryForm;
